import Vue from 'vue'
import axios from 'axios'
import auth from 'utils/auth'
import queryString from './qs'
import { has } from 'lodash'

axios.defaults.baseURL = window.b

/**
 * Request interceptor that adds the JWT.
 */
axios.interceptors.request.use(config => {
  if (auth.getToken()) {
    config.headers.common['Authorization'] = `Bearer ${auth.getToken()}`
  }

  return config
})

/**
 * Request and response interceptor that refreshes JWT and will also kick us
 * back to login if the JWT expires.
 */
axios.interceptors.response.use(response => {
  if (has(response.headers, 'authorization')) {
    auth.updateTokenFromHeader(response.headers.authorization)
  }

  return response
}, error => {
  if (error.response && error.response.status === 401) {
    auth.redirectOnTokenExpired()

    if (has(error.response.data, 'error')) {
      return Promise.reject(error)
    }

    return Promise.reject('Authentication token has been expired. Re-authentication required.')
  } else {
    // for any other status code we want to update the token from the request
    if (error.response && has(error.response.headers, 'authorization')) {
      auth.updateTokenFromHeader(error.response.headers.authorization)
    }

    return Promise.reject(error)
  }
})

// Setup the HTTP prototype on the Vue instance so we can access Axios
// much like how we access Vue Resource within our comnponents.
Vue.prototype.$http = axios

export default axios

export const url = (path, payload = {}) => {
  payload.token = auth.getToken()

  return `${window.b}/${path}?${queryString(payload)}`
}



// WEBPACK FOOTER //
// ./src/utils/http.js